import { DemoEndpoint } from '../../demo-service';
import { surroundingAreasEndpoint } from './mapping/surrounding-areas';

const mappingEndpoint: DemoEndpoint = {
  path: 'mapping',
  endpoints: [surroundingAreasEndpoint]
};

export { mappingEndpoint };
